import { render, staticRenderFns } from "./SongEditCard.vue?vue&type=template&id=2b595a2a&"
import script from "./SongEditCard.vue?vue&type=script&lang=js&"
export * from "./SongEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports